module.exports = __webpack_public_path__ + "img/d201104-1.85cc2b00.jpg";